(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-product-shortcodes"] && !Shopify.designMode) return;
  try {
    (() => {
  const initArticleProductSliders = root => {
    const scope = root || document;
    const sliders = scope.querySelectorAll('[data-article-product-slider]');

    sliders.forEach(slider => {
      if (slider.dataset.articleProductSliderReady === 'true') return;

      const track = slider.querySelector('[data-article-product-track]');
      const previousButton = slider.querySelector('[data-article-product-prev]');
      const nextButton = slider.querySelector('[data-article-product-next]');

      if (!track || !previousButton || !nextButton) return;

      slider.dataset.articleProductSliderReady = 'true';

      const productCards = Array.from(track.querySelectorAll('.productgrid--item'));

      const resetEqualHeights = () => {
        productCards.forEach(card => {
          card.style.removeProperty('--article-card-equal-height');
        });
        track.style.removeProperty('--article-track-action-space');
      };

      const equalizeCards = () => {
        resetEqualHeights();

        if (!productCards.length) return;

        let tallestCard = 0;
        let tallestActions = 0;

        productCards.forEach(card => {
          tallestCard = Math.max(tallestCard, card.getBoundingClientRect().height);

          const actions = card.querySelector('[data-product-actions]');
          if (actions) {
            tallestActions = Math.max(tallestActions, actions.getBoundingClientRect().height);
          }
        });

        const equalHeight = Math.ceil(tallestCard);

        productCards.forEach(card => {
          card.style.setProperty('--article-card-equal-height', `${equalHeight}px`);
        });

        if (window.matchMedia('(min-width: 901px)').matches && tallestActions > 0) {
          track.style.setProperty('--article-track-action-space', `${Math.ceil(tallestActions + 16)}px`);
        }
      };

      const getScrollAmount = () => {
        const card = track.querySelector('.productgrid--item');
        if (!card) return track.clientWidth;

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 2;

        const hasOverflow = maxScrollLeft > 2;
        previousButton.hidden = !hasOverflow;
        nextButton.hidden = !hasOverflow;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      let resizeFrame = null;
      window.addEventListener('resize', () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          equalizeCards();
          updateButtons();
        });
      });

      const scheduleEqualize = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            equalizeCards();
            updateButtons();
          });
        });
      };

      track.querySelectorAll('img').forEach(image => {
        if (!image.complete) {
          image.addEventListener('load', scheduleEqualize, { once: true });
        }
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleEqualize);
      }

      window.addEventListener('load', scheduleEqualize, { once: true });

      scheduleEqualize();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initArticleProductSliders(document));
  } else {
    initArticleProductSliders(document);
  }

  document.addEventListener('shopify:section:load', event => {
    initArticleProductSliders(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
